import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
// import ContactForm from "../components/ContactForm";
import '../contactstyle.css' ;
import '../style.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot , faStar , faPhone ,faEnvelope , faClock} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from 'react-helmet';
import ScrolltoTop from "../components/ScrolltoTop";


const Contact = () => {
    return(
        <>
         <Helmet>
                <title>TIRUN | Speak to India’s Cruise Booking Experts</title>
                <meta name="description" content="Get in touch with TIRUN's cruise experts. Reach out for bookings, cruise itineraries, or partnership opportunities. We’re here to help you sail seamlessly." />
              </Helmet>
 <div className="Contact-container">
        <Navbar/>
        
        <div className="offer-alert">
                       <div>
                           <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                          <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                          <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                           <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                           <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                       </div>
                       <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
         </div>
       
         <div className="contact-section">

        <div className="contact-details">

         <div className="address-container">
            <FontAwesomeIcon icon={faLocationDot} style={{color: '#ffffff', width:'20px', height:'25px'}} />
            <div>
            <h6>Address</h6>
            <p>TIRUN Travel Marketing, 505 Salcon Aurum, 4 Jasola District Centre, New Delhi 110025</p>
            </div>
         </div>

         <div className="phone-container">
            <FontAwesomeIcon icon={faPhone} style={{color: '#ffffff', width:'20px', height:'25px'}} />
            <div>
            <h6>India</h6>
            <p>1800-11-5464</p>
            <h6>International</h6>
            <p>+91-11-4906 1000</p>
            </div>
         </div>

         <div className="email-container">
            <FontAwesomeIcon icon={faEnvelope} style={{color: '#ffffff', width:'20px', height:'25px'}} />
            <div>
            <h6>Email</h6>
            <p>online@tirun.com</p>
            </div>
         </div>

         <div className="timing-container">
            <FontAwesomeIcon icon={faClock} style={{color: '#ffffff', width:'20px', height:'25px'}} />
            <div>
            <h6>Business Hours</h6>
            <p>Mon- Fri: 9:00 - 20:00<br></br>
            Saturdays: 9:30 - 18:00</p>
            </div>
         </div>

        </div>


        {/* <div className="contact-form-container">  
         <h2>Send Us Message</h2>
         <p>Request a callback from our cruise counsellors</p>  
          <ContactForm/>
        </div> */}

        </div>
        
        </div>
        <ScrolltoTop/>

        <Footer/>
        
        </>
    );
}


export default Contact ;